module.exports = __webpack_public_path__ + "img/p_sz_23.6862a18f.png";